class TopMenuDropDown {
  constructor(elem) {
    this.elem = elem;
    this.target = document.querySelector(this.elem.dataset.jsTopMenuDropdownTarget);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.init();
  }

  init() {
    if (!this.elem || !this.target) {
      return;
    }

    this.elem.addEventListener("click", (e) => {
      const clickedLink = e.target.closest("a");
      const isTrigger = clickedLink && this.elem.contains(clickedLink) && !this.target.contains(clickedLink);

      if (isTrigger) {
        e.preventDefault();
        this.toggle();
        return;
      }

      // Clic sur un item du sous-menu : laisser la navigation se faire
      if (this.target.contains(e.target)) {
        return;
      }
    });

    document.addEventListener("click", this.onDocumentClick);
  }

  toggle() {
    const opening = !this.target.classList.contains("show");
    this.closeAll();
    if (opening) {
      this.target.classList.add("show");
    }
  }

  close() {
    this.target.classList.remove("show");
  }

  closeAll() {
    document.querySelectorAll(".top-menu .submenu.show, .top-menu-admin .submenu.show").forEach((menu) => {
      menu.classList.remove("show");
    });
  }

  onDocumentClick(e) {
    if (!this.target.classList.contains("show")) {
      return;
    }
    if (this.elem.contains(e.target)) {
      return;
    }
    this.close();
  }
}

export default TopMenuDropDown;
